module.exports = __webpack_public_path__ + "static/img/wing_R780.a2cce75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_R780.jpg
// module id = dp9h
// module chunks = 0